// Dark electric-violet theme for Clerk's <SignIn>/<SignUp> components, matching
// the ChatRunner design system. Passed to ClerkProvider's `appearance` prop.

export const clerkAppearance = {
  variables: {
    colorPrimary: '#8b6bff',
    colorBackground: '#0f0f14',
    colorText: '#fafafa',
    colorTextSecondary: '#b6b6be',
    colorInputBackground: '#14141a',
    colorInputText: '#fafafa',
    colorDanger: '#f87171',
    colorSuccess: '#34d399',
    colorNeutral: '#fafafa',
    borderRadius: '10px',
    fontFamily: 'Inter, Tajawal, system-ui, sans-serif',
  },
  elements: {
    // We provide our own card/branding shell, so strip Clerk's outer chrome.
    rootBox: 'w-full',
    card: 'bg-transparent shadow-none border-0 w-full p-0',
    cardBox: 'shadow-none w-full',
    header: 'hidden', // we render our own bilingual title
    footer: 'bg-transparent',
    socialButtonsBlockButton:
      'border border-slate-300 bg-[#14141a] text-slate-900 hover:bg-[#1b1b22]',
    dividerLine: 'bg-slate-200',
    dividerText: 'text-slate-500',
    formFieldLabel: 'text-slate-600',
    formFieldInput:
      'bg-[#14141a] border border-slate-300 text-slate-900 focus:border-brand-500 focus:ring-brand-500',
    formButtonPrimary:
      'bg-brand-600 hover:bg-brand-700 text-white normal-case font-semibold shadow-[0_10px_40px_-10px_rgba(139,107,255,0.5)]',
    footerActionText: 'text-slate-500',
    footerActionLink: 'text-brand-500 hover:text-brand-700',
    identityPreviewText: 'text-slate-700',
    identityPreviewEditButtonIcon: 'text-brand-500',
    formFieldInputShowPasswordButton: 'text-slate-500',
    otpCodeFieldInput: 'bg-[#14141a] border border-slate-300 text-slate-900',
    badge: 'bg-brand-50 text-brand-500',
  },
} as const;
